import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';

import './PaymentReceipt.css';
import DatePicker from 'react-datepicker';

import { format } from "date-fns";

const PaymentReceipt = () => {

    const Navigate = useNavigate();
    const [fileErrors, setFileErrors] = useState({
        uploadFile: '',
    });
    const [payment, setPayment] = useState({
        trrnNo: "",
        challanStatus: "",
        challanGeneratedOn: "",
        establishmentId: "",
        establishmentName: "",
        challanType: "",
        totalMembers: "",
        wageMonth: "",
        totalAmount: "",
        account1Amount: "",
        account2Amount: "",
        account10Amount: "",
        account21Amount: "",
        account22Amount: "",
        paymentBank: "",
        crn: "",
        paymentDate: "",
        paymentConfirmationDate: "",
        totalPMRPYBenefit: "",
        uanFile: ""
    });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        gender: '',
        dateOfBirth: '',
        interviewDate: '',
        contactNumber: '',
        emailAddress: '',
        jobPosition: '',
        qualification: '',
        interviewDoneBy: '',
        aadharNumber: '',
    });
    const [isFocused, setIsFocused] = useState({ challanGeneratedOn: false, wageMonth: false, paymentDate: false, paymentConfirmationDate: false });
    const [successMessage, setSuccessMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPayment((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const fullName = localStorage.getItem("full_name");
        const role = localStorage.getItem("role");
        const employeeId = localStorage.getItem("employeeId");
        // Utility to convert comma numbers to plain numbers
        const parseNumber = (value) =>
            value ? Number(value.toString().replace(/,/g, "")) : 0;
        const request = {
            receipt: {
                trrnNo: payment.trrnNo,
                challanStatus: payment.challanStatus,
                challanGeneratedOn: payment.challanGeneratedOn,
                establishmentId: payment.establishmentId,
                establishmentName: payment.establishmentName,
                challanType: payment.challanType,
                totalMembers: parseNumber(payment.totalMembers),
                wageMonth: payment.wageMonth, // e.g. "SEP-2025"
                totalAmountRs: parseNumber(payment.totalAmount),
                account1AmountRs: parseNumber(payment.account1Amount),
                account2AmountRs: parseNumber(payment.account2Amount),
                account10AmountRs: parseNumber(payment.account10Amount),
                account21AmountRs: parseNumber(payment.account21Amount),
                account22AmountRs: parseNumber(payment.account22Amount),
                paymentConfirmationBank: payment.paymentBank,
                crn: payment.crn,
                paymentDate: payment.paymentDate,
                paymentConfirmationDate: payment.paymentConfirmationDate,
                totalPmrpyBenefit: parseNumber(payment.totalPMRPYBenefit),
            },
            auditLog: {
                name: fullName,
                role,
                employeeId,
            },
        };
        // 🧾 Build FormData
        const formData = new FormData();
        formData.append("request", new Blob([JSON.stringify(request)], { type: "application/json" }));
        if (payment.file) {
            formData.append("file", payment.file);
        }
        try {
            setLoading(true);
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/epf-receipts`, {
                method: "POST",
                body: formData,
            });
            if (!response.ok) {
                throw new Error("Failed to submit payment data");
            }
            const data = await response.json();
            console.log("✅ API Response:", data);
            setSuccessMessage("Payment data submitted successfully!");
            setTimeout(() => setSuccessMessage(""), 4000);
        } catch (error) {
            console.error("Failed to submit data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        Navigate('/dashboard');
    };

    const handleClear = () => {
        setPayment({
            trrnNo: "",
            challanStatus: "",
            challanGeneratedOn: "",
            establishmentId: "",
            establishmentName: "",
            challanType: "",
            totalMembers: "",
            wageMonth: "",
            totalAmount: "",
            account1Amount: "",
            account2Amount: "",
            account10Amount: "",
            account21Amount: "",
            account22Amount: "",
            paymentBank: "",
            crn: "",
            paymentDate: "",
            paymentConfirmationDate: "",
            totalPMRPYBenefit: "",
            uanFile: "",
        });
        setErrors({});
    };





    // Handle file changes with size & type validation
    const handleFileChange = (e, fieldName) => {
        const file = e.target.files[0];
        if (file) {
            // Example: limit file size to 5 MB (optional)
            const MAX_SIZE = 5 * 1024 * 1024; // 5MB

            if (file.size > MAX_SIZE) {
                setFileErrors((prev) => ({
                    ...prev,
                    [fieldName]: 'File size must be less than 5 MB',
                }));
                return;
            }

            // Optional: restrict allowed file types
            const allowedTypes = [
                'application/pdf',
                'image/jpeg',
                'image/png',
                'application/vnd.ms-excel',
            ];
            if (!allowedTypes.includes(file.type)) {
                setFileErrors((prev) => ({
                    ...prev,
                    [fieldName]: 'Only PDF, Excel, JPG, or PNG files are allowed',
                }));
                return;
            }

            // Clear any old errors
            setFileErrors((prev) => ({
                ...prev,
                [fieldName]: '',
            }));

            // ✅ Save the actual File object in state
            setPayment((prev) => ({
                ...prev,
                file: file, // <-- important: store the real file, not just metadata
            }));

            // Optional global cache (if needed elsewhere)
            if (!window._uploadedFiles) window._uploadedFiles = {};
            window._uploadedFiles[fieldName] = file;


        }
    };

    return (
        <React.Fragment>
            <div className="payment-container">
                <div className="payment-box">
                    <h2 className="payment-heading">
                        EPF Payment Confirmation Details
                    </h2>

                    <form onSubmit={handleSubmit}>
                        {/* TRRN No */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="trrnNo"
                                        value={payment.trrnNo}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>TRRN No</label>
                                </div>
                            </div>
                        </div>

                        {/* Challan Status */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="challanStatus"
                                        value={payment.challanStatus}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Challan Status</label>
                                </div>
                            </div>
                        </div>

                        {/* Challan Generated On */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className={`payment-floating-label-container-2 ${isFocused.challanGeneratedOn || !!payment.challanGeneratedOn ? 'float-label' : ''}`}>
                                    <DatePicker
                                        selected={payment.challanGeneratedOn ? new Date(payment.challanGeneratedOn) : null}
                                        onChange={(date) => setPayment((prev) => ({ ...prev, challanGeneratedOn: date }))}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="dd-MM-yyyy"
                                        className="did-floating-input"
                                    />

                                    <label><span className="required">*</span>Challan Generated On</label>
                                </div>
                            </div>
                        </div>

                        {/* Establishment ID */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="establishmentId"
                                        value={payment.establishmentId}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Establishment ID</label>
                                </div>
                            </div>
                        </div>

                        {/* Establishment Name */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="establishmentName"
                                        value={payment.establishmentName}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Establishment Name</label>
                                </div>
                            </div>
                        </div>

                        {/* Challan Type */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="challanType"
                                        value={payment.challanType}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Challan Type</label>
                                </div>
                            </div>
                        </div>

                        {/* Total Members */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="totalMembers"
                                        value={payment.totalMembers}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Total Members</label>
                                </div>
                            </div>
                        </div>

                        {/* Wage Month */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div
                                    className={`payment-floating-label-container-2 ${isFocused.wageMonth || !!payment.wageMonth ? "float-label" : ""
                                        }`}
                                >
                                    <DatePicker
                                        // Convert string back to Date for display
                                        selected={
                                            payment.wageMonth
                                                ? new Date(`${payment.wageMonth.split("-")[1]}-${payment.wageMonth.split("-")[0]}-01`)
                                                : null
                                        }
                                        onChange={(date) => {
                                            if (date) {
                                                // Store as string "SEP-2025"
                                                const formatted = format(date, "MMM-yyyy").toUpperCase();
                                                setPayment((prev) => ({ ...prev, wageMonth: formatted }));
                                            } else {
                                                setPayment((prev) => ({ ...prev, wageMonth: "" }));
                                            }
                                        }}
                                        dateFormat="MMM-yyyy"
                                        showMonthYearPicker
                                        placeholderText="MMM-yyyy"
                                        className="did-floating-input"
                                    />
                                    <label>
                                        <span className="required">*</span>Wage Month
                                    </label>
                                </div>
                            </div>
                        </div>


                        {/* Total Amount */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="totalAmount"
                                        value={payment.totalAmount}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Total Amount (RS)</label>
                                </div>
                            </div>
                        </div>

                        {/* Account 1 Amount */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="account1Amount"
                                        value={payment.account1Amount}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Account-1 Amount (RS)</label>
                                </div>
                            </div>
                        </div>

                        {/* Account 2 Amount */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="account2Amount"
                                        value={payment.account2Amount}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Account-2 Amount (RS)</label>
                                </div>
                            </div>
                        </div>

                        {/* Account 10 Amount */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="account10Amount"
                                        value={payment.account10Amount}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Account-10 Amount (RS)</label>
                                </div>
                            </div>
                        </div>

                        {/* Account 21 Amount */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="account21Amount"
                                        value={payment.account21Amount}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Account-21 Amount (RS)</label>
                                </div>
                            </div>
                        </div>

                        {/* Account 22 Amount */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="account22Amount"
                                        value={payment.account22Amount}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Account-22 Amount (RS)</label>
                                </div>
                            </div>
                        </div>

                        {/* Payment Bank */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="paymentBank"
                                        value={payment.paymentBank}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Payment Confirmation Bank</label>
                                </div>
                            </div>
                        </div>

                        {/* CRN */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="crn"
                                        value={payment.crn}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>CRN</label>
                                </div>
                            </div>
                        </div>

                        {/* Payment Date */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className={`payment-floating-label-container-2 ${isFocused.paymentDate || !!payment.paymentDate ? 'float-label' : ''}`}>
                                    <DatePicker
                                        selected={payment.paymentDate ? new Date(payment.paymentDate) : null}
                                        onChange={(date) =>
                                            setPayment((prev) => ({ ...prev, paymentDate: date }))
                                        }
                                        dateFormat="dd-MMM-yyyy"
                                        placeholderText="dd-MM-yyyy"
                                        className="did-floating-input"
                                    />
                                    <label><span className="required">*</span>Payment Date</label>
                                </div>
                            </div>
                        </div>

                        {/* Payment Confirmation Date */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className={`payment-floating-label-container-2 ${isFocused.paymentConfirmationDate || !!payment.paymentConfirmationDate ? 'float-label' : ''}`}>
                                    <DatePicker
                                        selected={payment.paymentConfirmationDate ? new Date(payment.paymentConfirmationDate) : null}
                                        onChange={(date) =>
                                            setPayment((prev) => ({ ...prev, paymentConfirmationDate: date }))
                                        }
                                        dateFormat="dd-MMM-yyyy"
                                        placeholderText="dd-MM-yyyy"
                                        className="did-floating-input"
                                    />
                                    <label><span className="required">*</span>Payment Confirmation Date</label>
                                </div>
                            </div>
                        </div>

                        {/* Total PMRPY Benefit */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="totalPMRPYBenefit"
                                        value={payment.totalPMRPYBenefit}
                                        onChange={handleChange}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Total PMRPY Benefit</label>
                                </div>
                            </div>
                        </div>
                        &nbsp;
                        {/* upload file */}
                        <div className="payment-maincontainer">
                            <div className="payment-container-part">
                                <div className="payment-input-label">
                                    <label>Upload File</label>
                                    <input
                                        type="file"
                                        name="file"
                                        onChange={(e) => handleFileChange(e, 'file')}
                                    />
                                </div>

                            </div>
                        </div>

                        {/* Buttons */}
                        <div className="payment-btn-div">
                            <button type="button" className="payment-cancel" onClick={handleCancel}>
                                Close
                            </button>
                            <button type="button" className="payment-clear" onClick={handleClear}>
                                Clear
                            </button>

                            <button
                                type="submit"
                                className="payment-btn"
                            //disabled={!isFormValid || loading || (isEditMode && !hasChanges)}
                            >
                                Save
                                {/* {loading ? (isEditMode ? "Updating..." : "Saving...") : isEditMode ? "Update" : "Save"} */}
                            </button>

                        </div>

                        {/* Popups */}
                        {/* {showSaveSuccess && (
                            <div className="confirm-overlay">
                                <div className="success-message-popup">
                                    {`${successMessage} Temporary ID: ${savedResponse}`}
                                </div>
                            </div>
                        )}

                        {showDialog && (
                            <div className="confirm-overlay">
                                <div className="success-message-popup">
                                    <h3>{`${successMessage} Temporary ID: ${savedResponse}`}</h3>
                                    <button onClick={handleDialogClose} className="dialog-ok-btn">
                                        OK
                                    </button>
                                </div>
                            </div>
                        )} */}
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
};
export default PaymentReceipt;